import type { DeviceType } from "@/common/hooks/use-device";

type ColumnWithVisibility = {
  visibility?: DeviceType[];
};

export function filterVisibleColumns<TColumn extends ColumnWithVisibility>(
  columns: TColumn[],
  deviceType: DeviceType | undefined,
): TColumn[] {
  return columns.filter((column) => !column.visibility || (!!deviceType && column.visibility.includes(deviceType)));
}
